import { create } from 'zustand';
import { authApi } from '../api/auth';

export const useAuthStore = create((set) => ({
  token: localStorage.getItem('lf_token') || null,
  user: JSON.parse(localStorage.getItem('lf_user') || 'null'),
  tenant: JSON.parse(localStorage.getItem('lf_tenant') || 'null'),
  loading: false,
  error: null,

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const { data } = await authApi.login({ email, password });
      localStorage.setItem('lf_token', data.token);
      localStorage.setItem('lf_user', JSON.stringify(data.user));
      localStorage.setItem('lf_tenant', JSON.stringify(data.tenant));
      set({ token: data.token, user: data.user, tenant: data.tenant, loading: false });
      return data;
    } catch (err) {
      const error = err.response?.data?.error || 'Login failed';
      set({ loading: false, error });
      throw new Error(error);
    }
  },

  register: async (formData) => {
    set({ loading: true, error: null });
    try {
      const { data } = await authApi.register(formData);
      localStorage.setItem('lf_token', data.token);
      localStorage.setItem('lf_user', JSON.stringify(data.user));
      localStorage.setItem('lf_tenant', JSON.stringify(data.tenant));
      set({ token: data.token, user: data.user, tenant: data.tenant, loading: false });
      return data;
    } catch (err) {
      const error = err.response?.data?.error || 'Registration failed';
      set({ loading: false, error });
      throw new Error(error);
    }
  },

  logout: () => {
    localStorage.removeItem('lf_token');
    localStorage.removeItem('lf_user');
    localStorage.removeItem('lf_tenant');
    set({ token: null, user: null, tenant: null });
  },

  refreshUser: async () => {
    try {
      const { data } = await authApi.me();
      localStorage.setItem('lf_user', JSON.stringify(data.user));
      localStorage.setItem('lf_tenant', JSON.stringify(data.tenant));
      set({ user: data.user, tenant: data.tenant });
    } catch (err) {
      // Token invalid — logout
      localStorage.removeItem('lf_token');
      localStorage.removeItem('lf_user');
      localStorage.removeItem('lf_tenant');
      set({ token: null, user: null, tenant: null });
    }
  },
}));
